export * from './ui/confirmar-dialog/confirmar-dialog.component';
